import englishMetaJson from '../../../../public/locales/en-US/CreatorDashboard.Landing.json';

const ASSET_BASE_PATH = `${process.env.assetPathPrefix}/landing`;
const OPEN_GRAPH_BASE_PATH = `${process.env.assetPathPrefix}/opengraph`;

export const landingOpenGraphImagePath = `${OPEN_GRAPH_BASE_PATH}/landing_og_image.jpg`;
export const devHubImagePath = `${ASSET_BASE_PATH}/docsite_slice.webp`;
export const devForumImagePath = `${ASSET_BASE_PATH}/devforum_slice.webp`;
export const creatorStoreImagePath = `${ASSET_BASE_PATH}/creatorStore_slice.webp`;

export const studioImagePath = `${ASSET_BASE_PATH}/studio.webp`;
export const studioMp4VideoPath = `${ASSET_BASE_PATH}/creator_dashboard_landing_video.mp4`;
export const studioWebmVideoPath = `${ASSET_BASE_PATH}/creator_dashboard_landing_video.webm`;
export const backDropPath = `${ASSET_BASE_PATH}/back_drop.webp`;

export const globalNetworkPath = `${ASSET_BASE_PATH}/global_network.webp`;
export const avatarProfilesPath = `${ASSET_BASE_PATH}/avatar_profiles.webp`;
export const makingPath = `${ASSET_BASE_PATH}/making.webp`;
export const logoDimension = '36';
export const figureDimension = '400';
export const metadataJson = englishMetaJson;
